// @flow
import React, { useCallback } from "react";
import className from "classnames";
import { connect } from "react-redux";
import { Translate } from "@quantum/i18n";

import {
  type ActionCreator,
  type TipoAtivo,
  getGrupamentosUtilizados,
  getGrupamentoMedidaSelecionado,
  isFiltroTipoAtivoSelecionado,
  selecionarGrupamentoMedida,
} from "../../../state";
import {
  type GrupamentoMedida,
  type GrupamentosMedida,
  GRUPAMENTO_MEDIDAS_EMPRESAS,
  TIPO_ATIVO_ACAO,
} from "../../../model";

import "./selecao-grupamento-medida.css";

type Props = {
  grupamentosMedida: Array<GrupamentoMedida>,
  grupamentoMedidaSelecionado: GrupamentosMedida,
  selecionarGrupamentoMedida: ActionCreator,
  isFiltroTipoAtivoSelecionado: TipoAtivo => boolean,
};

function SelecaoGrupamentoMedida({
  grupamentosMedida,
  grupamentoMedidaSelecionado,
  isFiltroTipoAtivoSelecionado,
  selecionarGrupamentoMedida,
}: Props) {
  const isGrupamentoDesabilitado = useCallback(
    grupamento =>
      grupamento.nome === GRUPAMENTO_MEDIDAS_EMPRESAS
        ? !isFiltroTipoAtivoSelecionado(TIPO_ATIVO_ACAO)
        : false,
    [isFiltroTipoAtivoSelecionado]
  );

  return (
    <div className="SelecaoGrupamentoMedida">
      <div className="SelecaoGrupamentoMedida__grupamentos">
        {grupamentosMedida.map(grupamento => (
          <label
            key={grupamento.nome}
            className={className("SelecaoGrupamentoMedida__grupamento", {
              "SelecaoGrupamentoMedida__grupamento--disabled": isGrupamentoDesabilitado(
                grupamento
              ),
            })}
          >
            <input
              type="radio"
              disabled={isGrupamentoDesabilitado(grupamento)}
              value={grupamento.nome}
              onChange={selecionarGrupamentoMedida}
              checked={grupamento.nome === grupamentoMedidaSelecionado}
            />
            <Translate>{grupamento.chaveTraducao}</Translate>
          </label>
        ))}
      </div>
    </div>
  );
}

export default connect(
  state => ({
    grupamentosMedida: getGrupamentosUtilizados(state),
    grupamentoMedidaSelecionado: getGrupamentoMedidaSelecionado(state),
    isFiltroTipoAtivoSelecionado: tipoAtivo =>
      isFiltroTipoAtivoSelecionado(tipoAtivo, state),
  }),
  {
    selecionarGrupamentoMedida: event =>
      selecionarGrupamentoMedida(event.target.value),
  }
)(SelecaoGrupamentoMedida);
